import {
  ELRIADSHRINE,
  AUCTOSELLERAPP,
  PEPSI,
  DINGG,
  KAASHIN,
  MYLONE,
  CANBIZ,
  NETGEAR,
  TOGETHER,
  ELEGANCIA,
  STORMLAKECAPITAL,
  XTAGAPP,
} from "./projectContent";

export const WORK_PROJECTS = [
  {
    ...ELRIADSHRINE,
    path: "ELRIADSHRINE",
    cardBg: "#F8F9FB",
    landingTitle: "Simplifying a high-traffic ticket booking experience to reduce drop-offs",
    tags: ["Web", "Ticketing", "Mobile"],
    outcome: "Reduced booking drop-offs with real-time seat selection",
  },
  {
    ...AUCTOSELLERAPP,
    path: "AUCTOSELLERAPP",
    cardBg: "#F0F4FF",
    landingTitle: "A mobile-first seller app for managing high-volume auction workflows",
    tags: ["Mobile", "SaaS", "Dashboard"],
    outcome: "Empowering industrial sellers to manage auctions on the go",
  },
  {
    ...PEPSI,
    path: "PEPSI",
    cardBg: "#EEF2FF",
    landingTitle: "Centralized Deal Management System for PepsiCo — data integrity, visibility, and auditability across Sales, Marketing, Finance, and Supply Chain",
    tags: ["Web & Mobile", "Business & Enterprise", "UI Design"],
    outcome: "Streamlined deal creation, approval, tracking, and analysis with cross-functional collaboration",
  },
  {
    ...DINGG,
    path: "DINGG",
    cardBg: "#FAFAFA",
    landingTitle: "Empowering Salon Management with Actionable Insights — scalable, intuitive scheduling and dashboard experience",
    tags: ["Web & Mobile", "SaaS & Enterprise", "UI Design"],
    outcome: "Clean dashboard with KPIs, trend analysis, real-time scheduler, and reduced cognitive load",
  },
  {
    ...KAASHIN,
    path: "KAASHIN",
    cardBg: "#F0F4FF",
    landingTitle: "A timeless brand identity for a boutique hotel in Varanasi",
    tags: ["Brand", "Logo", "Hospitality"],
    outcome: "Brand identity embodying Varanasi's serene essence",
  },
  {
    ...MYLONE,
    path: "MYLONE",
    cardBg: "#F8F9FB",
    landingTitle: "A fintech platform simplifying loan comparison and decision-making",
    tags: ["Web", "Fintech", "Mobile"],
    outcome: "Compare loan offers easily and apply quickly",
  },
  {
    ...CANBIZ,
    path: "CANBIZ",
    cardBg: "#F5F5F5",
    landingTitle: "Redesigned Business Model Canvas Tool — from Simventure Validate to Canbiz, with mobile-optimized UI and clear onboarding",
    tags: ["Web & Mobile", "Business & Enterprise", "UI Design"],
    outcome: "Modern, user-friendly BMC platform with dark theme, AI insights, and improved information architecture",
  },
  {
    ...NETGEAR,
    path: "NETGEAR",
    cardBg: "#FAFAFA",
    landingTitle: "Marketing and product emailers for NETGEAR Armor and Insight — clear, conversion-focused, and consistent with brand across devices",
    tags: ["Emailer", "Web & Mobile", "UI Design"],
    outcome: "Scalable, card-based emailer system with strong hierarchy and mobile responsiveness",
  },
  {
    ...TOGETHER,
    path: "TOGETHER",
    cardBg: "#F8F9FB",
    landingTitle: "Empowering agencies to grow smarter, faster, together — growth partnership platform for digital agencies",
    tags: ["Web", "Loan Comparison", "UI/UX Design"],
    outcome: "Expert guidance, subscription plans, and conversion-focused experience for agency scaling",
  },
  {
    ...ELEGANCIA,
    path: "ELEGANCIA",
    cardBg: "#F5F5F5",
    landingTitle: "Design a refined digital experience that reflects the brand's core values—discretion, trust, and elegance—for luxury real estate in Costa Rica and Central America",
    tags: ["Luxury", "Real Estate", "Web & Mobile"],
    outcome: "Curated, immersive digital experience for high-net-worth clients",
  },
  {
    ...STORMLAKECAPITAL,
    path: "STORMLAKECAPITAL",
    cardBg: "#F8F9FB",
    landingTitle: "Professional, trustworthy corporate website for a Detroit-based merchant banking and investment firm — clear value communication and conversion focus",
    tags: ["Web", "Banking", "UI/UX Design"],
    outcome: "Conversion-focused site with clear navigation, team profiles, and investment criteria",
  },
  {
    ...XTAGAPP,
    path: "XTAGAPP",
    cardBg: "#EEF2FF",
    landingTitle: "A seamless Reward Flow that motivates users, encourages participation, and clearly communicates progress and achievements within the NTRADEX ecosystem",
    tags: ["User flow", "User journey", "UI Design"],
    outcome: "Cohesive, frictionless reward experience with clear hierarchy and gamification",
  },
];
